<div class="item" style="height: calc(100vh - 450px); position: relative">
  <div class="table-container" *ngIf="tab === 'site'">
    <table class="table-header">
      <colgroup>
        <col width="25%"/>
        <col width="70%"/>
        <col width="5%"/>
      </colgroup>
      <thead>
        <tr>
          <th>Name</th>
          <th>Address</th>
          <th></th>
        </tr>
      </thead>
    </table>
    <div class="loader absolute" *ngIf="isLoading">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
      </svg>
    </div>
    <div class="table-body">
      <table>
        <colgroup>
          <col width="25%"/>
          <col width="70%"/>
          <col width="5%"/>
        </colgroup>
        <tbody>
          <tr *ngIf="!filteredSites?.length" style="text-align: center; color: #999;">
            <td>No Data</td>
          </tr>
          <tr class="has-child" *ngFor="let site of filteredSites">
            <td>{{site?.name}}</td>
            <td>{{site?.address1}} {{site?.address2 ? site?.address2 : ''}}</td>
            <td>
              <div class="more-content v-center" #actionMenus [id]="'target-'+site?.site_id" (mouseenter)="setMorePosition(site?.site_id)"><i class="material-icons-outlined more-icon" [class.show]="site.isShowMenu" (click)="$event.stopPropagation();toggleMenu(site)">more_horiz</i>
                <div class="more detail-more" [id]="'target-more-'+site.site_id" [class.visible]="site.isShowMenu">
                  <div class="btn-area" style="justify-content: flex-end;flex-direction:column">
                    <div class="text-button mb-7" (click)="$event.stopPropagation(); goToDetailSite(site?.site_id)">
                      <div class="btn-inner">Go to Detail</div>
                    </div>
                    <div class="text-button text-button-danger" *ngIf="hasPermissionRemoveSiteFormDivision()" (click)="$event.stopPropagation(); openDialogRemoveDataToDivision(site)">
                      <div class="btn-inner">Exclude from Branch</div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="table-container" *ngIf="tab === 'user'">
    <table class="table-header">
      <colgroup>
        <col width="6%"/>
        <col width="20%"/>
        <col width="20%"/>
        <col width="49%"/>
        <col width="5%"/>
      </colgroup>
      <thead>
        <tr>
          <th> </th>
          <th>Name</th>
          <th>Email</th>
          <th>Part of other Branches</th>
          <th> </th>
        </tr>
      </thead>
    </table>
    <div class="loader absolute" *ngIf="isLoading">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
      </svg>
    </div>
    <div *ngIf="!hasReadDivisionMemberPermission" style="font-size: 14px; margin: 8px">Permission Denied</div>
    <div class="table-body" *ngIf="hasReadDivisionMemberPermission">
      <table>
        <colgroup>
          <col width="6%"/>
          <col width="20%"/>
          <col width="20%"/>
          <col width="49%"/>
          <col width="5%"/>
        </colgroup>
        <tbody>
          <tr *ngIf="!filteredUsers?.length && !isLoading" style="text-align: center; color: #999;">
            <td></td>
            <td>No Data</td>
          </tr>
          <tr class="has-child" *ngFor="let user of filteredUsers" style="position: relative">
            <td> <img *ngIf="user.provider_picture" [src]="user.provider_picture" (error)="user.provider_picture=null"/>
              <div class="no-face" *ngIf="!user.provider_picture"></div>
            </td>
            <td>{{user?.firstname}} {{user?.lastname ? user?.lastname : ''}}</td>
            <td>{{user?.email}}</td>
            <td> 
              <div class="flex v-center" style="gap: 8px">
                <div class="user-division-tag" *ngFor="let division of user?.divisions" (click)="goToDetailDivision(division?.division_id)">
                  <div>{{division?.name}}</div>
                  <div class="division-tooltip">Go to Detail</div>
                </div>
              </div>
            </td>
            <td>
              <div class="more-content v-center" #actionMenus [id]="'target-'+user?.user_id" (mouseenter)="setMorePosition(user?.user_id)"><i class="material-icons-outlined more-icon" [class.show]="user.isShowMenu" (click)="$event.stopPropagation();toggleMenu(user)">more_horiz</i>
                <div class="more detail-more" [id]="'target-more-'+user.user_id" [class.visible]="user.isShowMenu">
                  <div class="btn-area" style="justify-content: flex-end;flex-direction:column">
                    <div class="text-button mb-7" (click)="$event.stopPropagation(); goToDetailUser(user?.user_id)">
                      <div class="btn-inner">Go to Detail</div>
                    </div>
                    <div class="text-button text-button-danger" *ngIf="hasDeleteDivisionMemberPermission" (click)="$event.stopPropagation(); openDialogRemoveDataToDivision(user)">
                      <div class="btn-inner">Exclude from Branch</div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>